import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import {
  shoppingCartList,
  shoppingCartCount,
  clearShoppingCart,
} from 'gatsby-theme-kn/src/utils/media_database_shopping_cart'
import MediaDatabasePromotialOrderItem from 'gatsby-theme-kn/src/components/technical/MediaDatabasePromotialOrderItem'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalMediaDatabasePromotialOrder from 'gatsby-theme-kn/src/components/modules/ModalMediaDatabasePromotialOrder'

const MediaDatabasePromotialOrder = ({ setter }) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(true)

  // Whoami, damit Formular-Felder vorbefüllt werden können
  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    {},
    'post'
  )

  // Modal: Shopping-Cart
  const [modalState, setModalState] = useState(false)
  const openModal = () => {
    setPartnerPortalUrl(apiURL('auth/whoami'))
    setModalState(true)
  }
  const closeModal = () => {
    setModalState(false)
  }

  return (
    <>
      <ModalModule
        isOpen={modalState}
        closeModal={closeModal}
        title="Werbemittelbestellung"
      >
        <ModalMediaDatabasePromotialOrder whoami={data} setter={setter} />
      </ModalModule>

      <section className={`media-cart active ${isOpen === true ? 'open' : ''}`}>
        <div className="media-cart-header" data-toggle="media-cart-state">
          <div className="media-cart-header-controls">
            <a
              title={t('generic.spa.media.index.clear')}
              className="btn btn-sm btn-secondary btn-plain"
              data-toggle="media-cart-clear"
              href="/"
              onClick={(e) => {
                e.preventDefault()
                clearShoppingCart(setter)
              }}
            >
              <i className="fal fa-shopping-cart"></i>
            </a>
            <a
              title={t('generic.spa.media.index.save')}
              className="btn btn-sm btn-primary btn-plain"
              data-toggle="media-cart-save"
              href="/"
              onClick={(e) => {
                e.preventDefault()
                openModal()
              }}
            >
              <i className="fal fa-chevron-right"></i>
              &nbsp;
              {t('generic.spa.media.index.order')}
            </a>
            {isOpen && (
              <a
                className="media-cart-toggle"
                href="/"
                onClick={(e) => {
                  e.preventDefault()
                  setIsOpen(false)
                }}
              >
                <i className="far fa-chevron-down"></i>
              </a>
            )}
            {!isOpen && (
              <a
                className="media-cart-toggle"
                href="/"
                onClick={(e) => {
                  e.preventDefault()
                  setIsOpen(true)
                }}
              >
                <i className="far fa-chevron-up"></i>
              </a>
            )}
          </div>
          <h5>
            {t('generic.spa.media.index.media_cart')}
            <span
              className="badge bg-primary media-cart-count"
              style={{ marginLeft: '0.25rem' }}
            >
              {shoppingCartCount()}
            </span>
          </h5>
        </div>
        <ul className="media-cart-list list-inline">
          {shoppingCartList().map((item, index) => (
            <MediaDatabasePromotialOrderItem
              item={item}
              setter={setter}
              displaySetsRecursive={false}
            />
          ))}
        </ul>
      </section>
    </>
  )
}

export default MediaDatabasePromotialOrder
